module.exports = __webpack_public_path__ + "img/orange.a107bb56.svg";